import React from 'react';

const AdminFileBox = ({ label, file, existingUrl, onChange, onClear, accept = '.pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*' }) => {
  const id = `admin-${label.replace(/\s+/g, '-')}`;
  return (
    <div>
      <label className="text-xs font-medium">{label}</label>
      {!file ? (
        <div className="mt-1 space-y-1">
          <label htmlFor={id} className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 hover:border-[#ee5e23] rounded-md py-3 px-2 cursor-pointer transition-colors bg-gray-50">
            <span className="text-xs text-gray-700 font-medium">Click to upload</span>
            <input id={id} type="file" accept={accept} className="hidden" onChange={onChange} />
          </label>
          {existingUrl && (
            <a href={existingUrl} target="_blank" rel="noreferrer" className="text-[11px] text-[#2c54b2] hover:underline block truncate">
              Current file ↗
            </a>
          )}
        </div>
      ) : (
        <div className="mt-1 flex items-center gap-2 border border-green-300 bg-green-50 rounded px-2 py-2">
          <div className="text-xs text-green-800 min-w-0 flex-1 truncate">{file.name}</div>
          <button type="button" onClick={onClear} className="text-gray-500 hover:text-red-600 p-0.5"><span>×</span></button>
        </div>
      )}
    </div>
  );
};

export default AdminFileBox;
